import { Injectable } from '@angular/core';
import type { MapboxMap } from '@polaris-customerweb/sharedcomponents.core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MapService } from './map.service';
import { WeatherLayerService } from './weather-layer.service';

@Injectable({ providedIn: 'root' })
export class WeatherService {
    constructor(
        private mapService: MapService,
        private weatherLayerService: WeatherLayerService
    ) {}

    addSources(mapboxMap: MapboxMap): void {
        this.mapService.addSource(
            mapboxMap,
            this.weatherLayerService.sourceIdCloudCover,
            this.weatherLayerService.sourceCloudCover
        );
        this.mapService.addSource(
            mapboxMap,
            this.weatherLayerService.sourceIdRadar,
            this.weatherLayerService.sourceRadar
        );
        this.mapService.addSource(
            mapboxMap,
            this.weatherLayerService.sourceIdSnowDepth,
            this.weatherLayerService.sourceSnowDepth
        );
    }

    addCloudCoverLayer(mapboxMap: MapboxMap): void {
        this.mapService.addLayer(
            mapboxMap,
            this.weatherLayerService.layerCloudCover
        );
    }

    addRadarLayer(mapboxMap: MapboxMap): void {
        this.mapService.addLayer(
            mapboxMap,
            this.weatherLayerService.layerRadar
        );
    }

    addSnowDepthLayer(mapboxMap: MapboxMap): void {
        this.mapService.addLayer(
            mapboxMap,
            this.weatherLayerService.layerSnowDepth
        );
    }

    removeCloudCoverLayer(mapboxMap: MapboxMap): void {
        this.mapService.removeLayer(
            mapboxMap,
            this.weatherLayerService.sourceIdCloudCover
        );
    }

    removeRadarLayer(mapboxMap: MapboxMap): void {
        this.mapService.removeLayer(
            mapboxMap,
            this.weatherLayerService.sourceIdRadar
        );
    }

    removeSnowDepthLayer(mapboxMap: MapboxMap): void {
        this.mapService.removeLayer(
            mapboxMap,
            this.weatherLayerService.sourceIdSnowDepth
        );
    }

    updateCloudCoverSource(mapboxMap: MapboxMap): Observable<string[]> {
        return this.updateSource(
            mapboxMap,
            this.weatherLayerService.apiLayerIdCloudCover,
            this.weatherLayerService.sourceIdCloudCover
        );
    }

    updateRadarSource(mapboxMap: MapboxMap): Observable<string[]> {
        return this.updateSource(
            mapboxMap,
            this.weatherLayerService.apiLayerIdRadar,
            this.weatherLayerService.sourceIdRadar
        );
    }

    updateSnowDepthSource(mapboxMap: MapboxMap): Observable<string[]> {
        return this.updateSource(
            mapboxMap,
            this.weatherLayerService.apiLayerIdSnowDepth,
            this.weatherLayerService.sourceIdSnowDepth
        );
    }

    updateSource(
        mapboxMap: MapboxMap,
        apiLayerId: string,
        sourceId: string
    ): Observable<string[]> {
        return this.weatherLayerService.getCurrentWeatherUris(apiLayerId).pipe(
            tap((tiles) => {
                this.mapService.setSourceProperty(
                    mapboxMap,
                    sourceId,
                    'tiles',
                    tiles
                );
            })
        );
    }
}
